// extracted by mini-css-extract-plugin
export default {"PagePreview":"styles_PagePreview__Ke6MC","active":"styles_active__pBV3+"};